module.exports = __webpack_public_path__ + "img/skin-btn.4225a424.svg";